// extracted by mini-css-extract-plugin
export default {"team":"Team_team__i-8Kz","mainTitle":"Team_mainTitle__2O5PU","desc":"Team_desc__VnCbO","smallTitle":"Team_smallTitle__HwIce","banner":"Team_banner__Dg1Cd"};